import type { FC } from 'react';

interface PaymentIconProps {
  color?: string;
}

export const PaymentIcon: FC<PaymentIconProps> = ({ color = '#E6E6E9' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path
      d="M2 6.50016H14M4.66667 10.5002H6M4.13333 13.1668H11.8667C12.6134 13.1668 12.9868 13.1668 13.272 13.0215C13.5229 12.8937 13.7269 12.6897 13.8547 12.4388C14 12.1536 14 11.7802 14 11.0335V5.96683C14 5.2201 14 4.84672 13.8547 4.56151C13.7269 4.31062 13.5229 4.10665 13.272 3.97882C12.9868 3.8335 12.6134 3.8335 11.8667 3.8335H4.13333C3.3866 3.8335 3.01323 3.8335 2.72801 3.97882C2.47713 4.10665 2.27315 4.31062 2.14533 4.56151C2 4.84672 2 5.22009 2 5.96683V11.0335C2 11.7802 2 12.1536 2.14533 12.4388C2.27315 12.6897 2.47713 12.8937 2.72801 13.0215C3.01323 13.1668 3.38659 13.1668 4.13333 13.1668Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
